import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { AdminLoginForm } from '@/features/auth/components/AdminLoginForm';
import i18n from '@/shared/i18n';
import { PageTransition } from '@/shared/motion';

export const Route = createFileRoute('/_auth/admin/login')({
  // The admin console is English-only. Pin the locale to English BEFORE the page
  // renders (awaited here, not in a post-paint effect) so the brand pane AND the
  // form paint once as LTR/English — no mixed or half-flipped Arabic/English state.
  beforeLoad: async () => {
    if (!i18n.language.startsWith('en')) await i18n.changeLanguage('en');
  },
  component: AdminLoginRoute,
});

function AdminLoginRoute() {
  const navigate = useNavigate();
  return (
    <PageTransition className="flex flex-col gap-6">
      <AdminLoginForm
        onSuccess={() => {
          void navigate({ to: '/admin' });
        }}
      />
    </PageTransition>
  );
}
